import {ServicedMeasurement} from "../models/ServicedMeasurement";
import {ServicedMeasurementImportTemplate} from "./ServicedMeasurementImportTemplate";
import {ServicedMeasurementTemplateData} from "./ServicedMeasurementTemplateData";
import {cloneDeep} from "lodash";

export const getServicedMeasurementTemplate = (data: ServicedMeasurement) => {
    return ServicedMeasurementImportTemplate(prepareData(data))
};

const prepareData = (documentData: ServicedMeasurement) => {
    const templateData: ServicedMeasurementTemplateData = {
        documentOfImport: cloneDeep(documentData)
    };
    return templateData;
}
